<div class="product-container">
  <div class="product-header">
    <h2>{{ productId ? (isEditMode ? 'Edit Product' : 'View Product') : 'Create New Product' }}</h2>
    <div class="header-actions" *ngIf="productId && !isEditMode">
      <button mat-raised-button color="accent" (click)="enterEditMode()" type="button">
        <mat-icon>edit</mat-icon> Edit
      </button>
    </div>
  </div>

  
  <div *ngIf="loading" class="loading-message">
    <p>Loading product data...</p>
  </div>

  <div *ngIf="error" class="error-message">
    <p>{{ error }}</p>
    <button mat-raised-button color="primary" (click)="loadProduct(productId!)">Retry</button>
  </div>

  <form *ngIf="!loading" [formGroup]="productForm" (ngSubmit)="onSubmit()" class="product-form">
    <!-- Basic Information Section -->
    <h3>Basic Information</h3>
    <div class="form-row">
      <mat-form-field appearance="outline" class="form-field">
        <mat-label>Product Name</mat-label>
        <input matInput formControlName="name" placeholder="Enter product name" [readonly]="!isEditMode">
        <mat-error *ngIf="productForm.get('name')?.hasError('required')">
          Product name is required
        </mat-error>
      </mat-form-field>

      <mat-form-field appearance="outline" class="form-field">
        <mat-label>Catalog Number</mat-label>
        <input matInput formControlName="catalogNum" placeholder="Enter catalog number" [readonly]="!isEditMode">
      </mat-form-field>
    </div>

    <div class="form-row">
      <mat-form-field appearance="outline" class="form-field">
        <mat-label>Type</mat-label>
        <mat-select formControlName="productType" [disabled]="!isEditMode">
          <mat-option [value]="null">-- None --</mat-option>
          <mat-option *ngFor="let pt of productTypes" [value]="pt">
            {{pt}}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>

    <div class="form-row">
      <mat-form-field appearance="outline" class="form-field-full">
        <mat-label>Description</mat-label>
        <textarea matInput formControlName="description" rows="3" placeholder="Enter product description" [readonly]="!isEditMode"></textarea>
      </mat-form-field>
    </div>

    <!-- Vendor Product Information Section -->
    <div style="display: none;">
    <div class="section-header">
      <h3>Vendor Product Information</h3>
      <button mat-mini-fab color="primary" type="button" (click)="addVendorProduct()" matTooltip="Add Vendor Product" *ngIf="isEditMode">
        <mat-icon>add</mat-icon>
      </button>
    </div>
    <div formArrayName="vendorProducts">
      <div *ngFor="let vpGroup of vendorProductsArray.controls; let i = index"
           [formGroupName]="i"
           class="vendor-product-entry">

        <div class="vendor-product-header" *ngIf="vendorProductsArray.length > 1 || isEditMode">
          <span *ngIf="vendorProductsArray.length > 1" class="vendor-product-label">
            {{ vpGroup.get('vendorSearch')?.value?.name || vpGroup.get('vendorSearch')?.value?.Name || ('Vendor Product ' + (i + 1)) }}
          </span>
          <button mat-icon-button color="warn" type="button"
                  *ngIf="isEditMode && vendorProductsArray.length > 1"
                  (click)="removeVendorProduct(i); $event.stopPropagation()"
                  matTooltip="Remove vendor product">
            <mat-icon>delete</mat-icon>
          </button>
        </div>

        <div class="form-row">
          <mat-form-field appearance="outline" class="form-field">
            <mat-label>Vendor</mat-label>
            <mat-icon matPrefix>search</mat-icon>
            <input matInput
                   formControlName="vendorSearch"
                   placeholder="Search vendor by name or ID"
                   [readonly]="!isEditMode"
                   [matAutocomplete]="autoVendor">
            <button mat-icon-button matSuffix
                    *ngIf="isEditMode && vpGroup.get('vendorSearch')?.value"
                    (click)="clearVendor(i); $event.stopPropagation()"
                    type="button"
                    matTooltip="Clear vendor">
              <mat-icon>close</mat-icon>
            </button>
            <button mat-icon-button matSuffix
                    *ngIf="!vpGroup.get('vendorSearch')?.value && vpGroup.get('vendorId')?.value"
                    (click)="viewVendor(i)"
                    type="button"
                    matTooltip="View Vendor Details">
              <mat-icon>open_in_new</mat-icon>
            </button>
            <mat-autocomplete #autoVendor="matAutocomplete"
                              [displayWith]="displayVendor.bind(this)"
                              (optionSelected)="onVendorSelected($event.option.value, i)">
              <mat-option *ngFor="let vendor of filteredVendors[i] | async" [value]="vendor">
                {{ vendor.name || vendor.Name }} (ID: {{ vendor.id || vendor.Id }})
              </mat-option>
            </mat-autocomplete>
          </mat-form-field>
        </div>

        <div class="form-row">
          <mat-form-field appearance="outline" class="form-field">
            <mat-label>Vendor Catalog Number</mat-label>
            <input matInput formControlName="catalogNum" placeholder="Enter vendor catalog number" [readonly]="!isEditMode">
          </mat-form-field>

          <mat-form-field appearance="outline" class="form-field">
            <mat-label>Vendor Lot Number</mat-label>
            <input matInput formControlName="lotNum" placeholder="Enter vendor lot number" [readonly]="!isEditMode">
          </mat-form-field>
        </div>

      </div>

    </div>

    </div>

    <!-- Inventory Section -->
    <h3>Inventory</h3>
    <div class="form-row">
      <mat-form-field appearance="outline" class="form-field">
        <mat-label>Qty On Hand</mat-label>
        <input matInput type="number" [value]="totalQuantityOnHand" readonly>
      </mat-form-field>

      <mat-form-field appearance="outline" class="form-field">
        <mat-label>Qty Reserved</mat-label>
        <input matInput type="number" [value]="totalQuantityReserved" readonly>
      </mat-form-field>

      <mat-form-field appearance="outline" class="form-field">
        <mat-label>Qty Available</mat-label>
        <input matInput type="number" [value]="totalQuantityAvailable" readonly>
      </mat-form-field>
    </div>

    <!-- Lot Numbers Section -->
    <div class="section-header">
      <h3>Lot Numbers</h3>
      <button mat-mini-fab color="primary" type="button" (click)="addLotNum(0)" matTooltip="Add Lot Number" *ngIf="isEditMode">
        <mat-icon>add</mat-icon>
      </button>
    </div>
    <mat-accordion>
      <ng-container *ngFor="let vpGroup of vendorProductsArray.controls; let i = index">
        <mat-expansion-panel *ngFor="let ln of getLotNumsArray(i).controls; let j = index" [formGroup]="getLotNumFormGroup(i, j)">
          <mat-expansion-panel-header>
            <mat-panel-title class="lot-panel-title">
              <span class="lot-panel-number">{{ getLotNumsArray(i).at(j).get('number')?.value || ('Lot ' + (j + 1)) }}</span>
              <span class="lot-panel-meta" *ngIf="vendorProductsArray.length > 1">
                &nbsp;&mdash;&nbsp;{{ vpGroup.get('vendorSearch')?.value?.name || vpGroup.get('vendorSearch')?.value?.Name || ('Vendor ' + (i + 1)) }}
              </span>
            </mat-panel-title>
            <mat-panel-description>
              <button mat-icon-button color="warn" type="button"
                      *ngIf="isEditMode"
                      (click)="removeLotNum(i, j); $event.stopPropagation()"
                      matTooltip="Remove lot number">
                <mat-icon>delete</mat-icon>
              </button>
            </mat-panel-description>
          </mat-expansion-panel-header>

          <!-- internal Lot # row -->
          <div class="form-row">
            <mat-form-field appearance="outline" class="form-field">
                <mat-label>Lot Number</mat-label>
                <input matInput formControlName="number" placeholder="Enter lot number" [readonly]="!isEditMode">
            </mat-form-field>
            <button mat-icon-button type="button" color="primary"
                    *ngIf="isEditMode"
                    (click)="fetchLatestLotNumber(i, j)"
                    matTooltip="Suggest next lot number">
              <mat-icon>autorenew</mat-icon>
            </button>
          </div>

          <!-- Vendor, Vendor Lot # -->
          <div class="form-row">
            <div [formGroup]="getVpFormGroup(i)" class="form-field-inline-group">
              <mat-form-field appearance="outline" class="form-field">
                <mat-label>Vendor</mat-label>
                <mat-icon matPrefix>search</mat-icon>
                <input matInput
                       formControlName="vendorSearch"
                       placeholder="Search vendor"
                       [readonly]="!isEditMode"
                       [matAutocomplete]="autoVendorLot">
                <button mat-icon-button matSuffix
                        *ngIf="isEditMode && vpGroup.get('vendorSearch')?.value"
                        (click)="clearVendor(i); $event.stopPropagation()"
                        type="button" matTooltip="Clear vendor">
                  <mat-icon>close</mat-icon>
                </button>
                <mat-autocomplete #autoVendorLot="matAutocomplete"
                                  [displayWith]="displayVendor.bind(this)"
                                  (optionSelected)="onVendorSelected($event.option.value, i)">
                  <mat-option *ngFor="let vendor of filteredVendors[i] | async" [value]="vendor">
                    {{ vendor.name || vendor.Name }} (ID: {{ vendor.id || vendor.Id }})
                  </mat-option>
                </mat-autocomplete>
              </mat-form-field>

              <mat-form-field appearance="outline" class="form-field">
                <mat-label>Vendor Catalog Number</mat-label>
                <input matInput formControlName="catalogNum" placeholder="Vendor catalog number" [readonly]="!isEditMode">
              </mat-form-field>
            </div>

            <mat-form-field appearance="outline" class="form-field">
              <mat-label>Vendor Lot Number</mat-label>
              <input matInput formControlName="vendorLotNum" placeholder="Enter vendor lot number" [readonly]="!isEditMode">
            </mat-form-field>
          </div>

          <div class="form-row">
            <mat-form-field appearance="outline" class="form-field">
              <mat-label>Qty Received</mat-label>
              <input matInput type="number" formControlName="quantityReceived" placeholder="0" [readonly]="(getLotNumsArray(i).at(j).get('id')?.value ?? 0) > 0">
            </mat-form-field>

            <mat-form-field appearance="outline" class="form-field">
              <mat-label>Unit Type</mat-label>
              <mat-select formControlName="unitType" [disabled]="!isEditMode">
                <mat-option value="">-- None --</mat-option>
                <mat-option *ngFor="let ut of unitTypes" [value]="ut">{{ ut }}</mat-option>
              </mat-select>
            </mat-form-field>
          </div>

          <div class="form-row">
            <mat-form-field appearance="outline" class="form-field">
              <mat-label>Qty On Hand</mat-label>
              <input matInput type="number" formControlName="quantityOnHand" placeholder="0" [readonly]="(getLotNumsArray(i).at(j).get('id')?.value ?? 0) > 0">
            </mat-form-field>

            <mat-form-field appearance="outline" class="form-field">
              <mat-label>Qty Reserved</mat-label>
              <input matInput type="number" formControlName="quantityReserved" placeholder="0" [readonly]="(getLotNumsArray(i).at(j).get('id')?.value ?? 0) > 0">
            </mat-form-field>

            <mat-form-field appearance="outline" class="form-field">
              <mat-label>Qty Available</mat-label>
              <input matInput type="number"
                [value]="(getLotNumsArray(i).at(j).get('quantityOnHand')?.value ?? 0) - (getLotNumsArray(i).at(j).get('quantityReserved')?.value ?? 0)"
                placeholder="0" readonly>
            </mat-form-field>
          </div>

          <div class="form-row">
              <mat-form-field appearance="outline" class="form-field">
                <mat-label>Concentration</mat-label>
                <input matInput type="number" step="any" formControlName="concentration" placeholder="0.0" [readonly]="!isEditMode">
              </mat-form-field>

              <mat-form-field appearance="outline" class="form-field">
                <mat-label>Activity Unit</mat-label>
                <mat-select formControlName="ActivityType" [disabled]="!isEditMode">
                  <mat-option value="">-- None --</mat-option>
                  <mat-option *ngFor="let activityType of activityTypes" [value]="activityType.value">
                    {{ activityType.displayName }}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </div>

          <div class="form-row">
            <mat-form-field appearance="outline" class="form-field">
              <mat-label>Manufacture Date</mat-label>
              <input matInput type="date" formControlName="manufactureDate" [readonly]="!isEditMode">
            </mat-form-field>

            <mat-form-field appearance="outline" class="form-field">
              <mat-label>Expiration Date</mat-label>
              <input matInput type="date" formControlName="expirationDate" [readonly]="!isEditMode">
            </mat-form-field>
          </div>

          <div class="form-row">
            <mat-form-field appearance="outline" class="form-field-full">
              <mat-label>Notes</mat-label>
              <textarea matInput formControlName="notes" rows="2" placeholder="Notes" [readonly]="!isEditMode"></textarea>
            </mat-form-field>
          </div>

        </mat-expansion-panel>
      </ng-container>
    </mat-accordion>
    <div class="empty-message" *ngIf="allLotNumsCount === 0">
      <span *ngIf="!isEditMode">No lot numbers found.</span>
      <span *ngIf="isEditMode">No lot numbers added. Click + to add a lot number.</span>
    </div>

    <!-- Matched Pairs Section -->
    <!-- <div class="section-header">
      <h3>Matched Pairs</h3>
      <button mat-mini-fab color="primary" type="button" (click)="addMatchedPair()" matTooltip="Add Matched Pair" *ngIf="false">
        <mat-icon>add</mat-icon>
      </button>
    </div>
    <mat-form-field appearance="outline" class="lot-num-search-field">
      <mat-label>Search Matched Pairs</mat-label>
      <mat-icon matPrefix>search</mat-icon>
      <input matInput [(ngModel)]="matchedPairSearch" [ngModelOptions]="{standalone: true}" placeholder="Filter by solid phase or detection antibody">
      <button mat-icon-button matSuffix *ngIf="matchedPairSearch" type="button" (click)="matchedPairSearch = ''" matTooltip="Clear search">
        <mat-icon>close</mat-icon>
      </button>
    </mat-form-field>
    <mat-accordion formArrayName="matchedPairs">
      <mat-expansion-panel *ngFor="let i of filteredMatchedPairIndices" [formGroupName]="i">
        <mat-expansion-panel-header>
          <mat-panel-title class="lot-panel-title">
            <span class="lot-panel-number">Solid Phase ID: {{ matchedPairsArray.at(i).get('solidPhaseProductId')?.value || ('Pair ' + (i + 1)) }}</span>
            <span class="lot-panel-meta" *ngIf="matchedPairsArray.at(i).get('detectionProductId')?.value">
              &nbsp;&mdash;&nbsp;Detection Product ID: {{ matchedPairsArray.at(i).get('detectionProductId')?.value }}
            </span>
          </mat-panel-title>
          <mat-panel-description>
            <button mat-icon-button color="warn" type="button"
                    *ngIf="isEditMode"
                    (click)="removeMatchedPair(i); $event.stopPropagation()"
                    matTooltip="Remove matched pair">
              <mat-icon>delete</mat-icon>
            </button>
          </mat-panel-description>
        </mat-expansion-panel-header>

        <div class="form-row">
          <mat-form-field appearance="outline" class="form-field">
            <mat-label>Solid Phase Product ID</mat-label>
            <input matInput type="number" formControlName="solidPhaseProductId" placeholder="Enter product ID" [readonly]="!isEditMode">
          </mat-form-field>

          <mat-form-field appearance="outline" class="form-field">
            <mat-label>Detection Product ID</mat-label>
            <input matInput type="number" formControlName="detectionProductId" placeholder="Enter product ID" [readonly]="!isEditMode">
          </mat-form-field>
        </div>

        <div class="form-row">
          <mat-form-field appearance="outline" class="form-field-full">
            <mat-label>Comments</mat-label>
            <textarea matInput formControlName="comments" rows="2" placeholder="Comments" [readonly]="!isEditMode"></textarea>
          </mat-form-field>
        </div>

      </mat-expansion-panel>
    </mat-accordion>
    <div class="empty-message" *ngIf="matchedPairsArray.length === 0">
      <span *ngIf="!isEditMode">No matched pairs found.</span>
      <span *ngIf="isEditMode">No matched pairs added. Click + to add a matched pair.</span>
    </div> -->

    <!-- Integration Information Section -->
    <div style="display: none;">
      <h3>Integration Information</h3>
      <div class="form-row">
        <mat-form-field appearance="outline" class="form-field">
          <mat-label>QuickBooks Product ID</mat-label>
          <input matInput type="number" formControlName="qboProductId" placeholder="Enter QuickBooks ID">
        </mat-form-field>
      </div>
    </div>

    <div class="form-actions" *ngIf="isEditMode">
      <button mat-raised-button color="primary" type="submit" [disabled]="!productForm.valid">
        Save
      </button>
      <button mat-raised-button type="button" (click)="onCancel()">
        Cancel
      </button>
    </div>
  </form>

  <!-- Price History (view mode only) -->
  <ng-container *ngIf="productId && !isEditMode">

    <!-- Price History -->
    <div class="history-section">
      <h3>Price History</h3>
      <div *ngIf="priceHistoryLoading" class="history-loading">Loading price history...</div>

      <div *ngIf="!priceHistoryLoading" class="table-container">
        <!-- Search Filter -->
        <mat-form-field class="filter-field">
          <mat-label>Search price history</mat-label>
          <input matInput (keyup)="applyPriceHistoryFilter($event)" placeholder="Search by customer, lot, order..." #priceHistoryInput>
          <mat-icon matSuffix>search</mat-icon>
        </mat-form-field>

        <table mat-table [dataSource]="priceHistoryDataSource" matSort class="history-table">
          <ng-container matColumnDef="date">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Date</th>
            <td mat-cell *matCellDef="let row">{{ row.date | date:'MM/dd/yyyy' }}</td>
          </ng-container>
          <ng-container matColumnDef="customer">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Customer</th>
            <td mat-cell *matCellDef="let row" class="link-cell" (click)="goToCustomer(row.customerId)">{{ row.customer }}</td>
          </ng-container>
          <ng-container matColumnDef="unitPrice">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Price</th>
            <td mat-cell *matCellDef="let row">{{ row.unitPrice | currency }}</td>
          </ng-container>
          <ng-container matColumnDef="costPerUnit">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Cost</th>
            <td mat-cell *matCellDef="let row">{{ row.costPerUnit | currency }}</td>
          </ng-container>
          <ng-container matColumnDef="net">
            <th mat-header-cell *matHeaderCellDef mat-sort-header="netPercent">Net</th>
            <td mat-cell *matCellDef="let row">{{ formatNet(row.netPercent) }}</td>
          </ng-container>
          <ng-container matColumnDef="lotNumber">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Lot Number</th>
            <td mat-cell *matCellDef="let row">{{ row.lotNumber }}</td>
          </ng-container>
          <ng-container matColumnDef="salesOrderNumber">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>SalesOrder</th>
            <td mat-cell *matCellDef="let row" class="link-cell" (click)="goToSalesOrder(row.salesOrderId)">{{ row.salesOrderNumber }}</td>
          </ng-container>
          <tr mat-header-row *matHeaderRowDef="priceHistoryColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: priceHistoryColumns;" class="table-row"></tr>

          <!-- No Data Row -->
          <tr class="mat-row" *matNoDataRow>
            <td class="mat-cell no-data" [attr.colspan]="priceHistoryColumns.length">
              <div class="no-records">
                <p *ngIf="!priceHistoryInput.value">No price history found.</p>
                <p *ngIf="priceHistoryInput.value">No price history matches "{{ priceHistoryInput.value }}"</p>
              </div>
            </td>
          </tr>
        </table>

        <!-- Paginator -->
        <mat-paginator
          [pageSizeOptions]="[5, 10, 25, 50]"
          [pageSize]="10"
          showFirstLastButtons
          aria-label="Select page of price history">
        </mat-paginator>
      </div>
    </div>

  </ng-container>

</div>
